// extracted by mini-css-extract-plugin
module.exports = {"aboutTagline":"about-page-module--aboutTagline--3QXmG","aboutTaglineText":"about-page-module--aboutTaglineText--HKOR_"};